import React from "react";
import {
  Box,  
  Typography,
  Card,
  CardContent,
  Button,
  IconButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DownloadIcon from "@mui/icons-material/Download";
import BarChartIcon from "@mui/icons-material/BarChart";
import Grid from '@mui/material/Grid2';
import logo from '../../assets/smt-logo.webp';
import PieChartWithNeedle from "./components/Dashboard/PiechartWithNeedle";
import PieChartWithLabel from "./components/Dashboard/PieChartWithLabel";
import BarChart from "./components/Dashboard/BarChart";

const data = [
  { name: "A", value: 80, color: "#53C6FF" },
  { name: "B", value: 45, color: "#006CA3" },
  { name: "C", value: 25, color: "#023047" },
];
const value = 50;


const Circledata = [
  { name: 'Group A', value: 400},
  { name: 'Group B', value: 300}
];

const customColors = ['#023047', '#006CA3'];

const BarChartData = [
  { name: "Travel", amount: 120 },
  { name: "Meals", amount: 200 },
  { name: "Print", amount: 180 },
  { name: "Supplies", amount: 80 },
  { name: "Fuel", amount: 100 },
  { name: "Others", amount: 150 },
];

function Dashboard() {
  return (
    <Grid container direction="column" alignItems="center" justifyContent="center">      
      <Grid item>
        <Typography fontSize="24px" fontWeight="700px">KPI Tracker</Typography>
      </Grid>

      <Grid item container justifyContent="space-between" width="80%">
      <Grid item container direction="column" justifyContent="center" alignItems="center" spacing={0}>
        <PieChartWithNeedle 
          data={data}
          value={value}
          cx={175}
          cy={150}
          iR={80}
          oR={150}
          needleColor="#C2C2C2"
        />
        <Typography fontSize="20px" fontWeight="500px">Material Consumed</Typography>
        <Typography fontSize="24px" fontWeight="700px">92%</Typography>
      </Grid>
      <Grid item container direction="column" justifyContent="center" alignItems="center" spacing={0}>
        <PieChartWithNeedle 
          data={data}
          value={value}
          cx={175}
          cy={150}
          iR={80}
          oR={150}
          needleColor="#C2C2C2"
        />
        <Typography fontSize="20px" fontWeight="500px">Material Consumed</Typography>
        <Typography fontSize="24px" fontWeight="700px">88%</Typography>
      </Grid> 
      </Grid>

      <Grid item container justifyContent="space-between" width="80%">
        <Grid item container direction="column" justifyContent="center" alignItems="center" spacing={0}>
          <PieChartWithLabel data={Circledata} colors={customColors} />
          <Typography fontSize="20px" fontWeight="500px">Material Dispatch & Return</Typography>
        </Grid>
        <Grid item spacing={0}>
          <BarChart data={BarChartData} dataKey="amount" fill="#023047" />
        </Grid>
      </Grid>
    </Grid>
    
  );
}

export default Dashboard;